import { Box, Divider } from "@mui/material"
import type { FC } from "react"
import type { Control } from "react-hook-form"

import { PRODUCT_TEST_DOCUMENT_TYPE_TO_CHIP, PRODUCT_TEST_DOCUMENT_TYPE_TO_LABEL } from "../constants"

import { FilesTable } from "@/components/Tables/Aeros/components/FilesTable"
import { useFileColumns } from "@/components/Tables/Aeros/hooks/useFileColumns"
import { DOCUMENT_UPLOAD_MIME_TYPES, DOCUMENT_UPLOAD_TYPES_LABEL } from "@/components/upload/constants"
import { MultiFileUpload } from "@/components/upload/MultiFileUpload/MultiFileUpload"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

const documentTypeOptions: Option<string>[] = Object.entries(PRODUCT_TEST_DOCUMENT_TYPE_TO_LABEL).map(
  ([value, label]) => ({
    value,
    label,
  })
)

interface ProductTestDocumentsFormProps {
  title: string
  control: Control<any>
  readOnly?: boolean
  productTestDocuments?: SignedUrl[]
  onDelete?: (document: SignedUrl) => void
}

export const ProductTestDocumentsForm: FC<ProductTestDocumentsFormProps> = ({
  title,
  control,
  readOnly = false,
  productTestDocuments = [],
  onDelete = () => {},
}) => {
  const columns = useFileColumns({
    typeToChip: PRODUCT_TEST_DOCUMENT_TYPE_TO_CHIP,
    canDownload: false,
    onDelete,
  })

  return (
    <Box component='fieldset'>
      <legend className='font-medium tracking-[0.2px] text-gray-700'>{title}</legend>
      <Divider className='mb-6 mt-1' />
      {productTestDocuments.length > 0 && (
        <Box className='mb-6'>
          <FilesTable data={productTestDocuments} isLoading={false} columns={columns} />
        </Box>
      )}
      {!readOnly && (
        <MultiFileUpload
          control={control}
          name='documents'
          documentTypeOptions={documentTypeOptions}
          withDescription
          allowedMimeTypes={DOCUMENT_UPLOAD_MIME_TYPES}
          allowedTypesLabel={DOCUMENT_UPLOAD_TYPES_LABEL}
          testIdPrefix='product-test-documents.multi-file-upload'
        />
      )}
    </Box>
  )
}
